module.exports = __webpack_public_path__ + "img/inspiration2.867fce8b.png";